<div class="modal-wrapper">
	<div class="modal-header">
    <h1 class="modal-title" [innerHTML]="data.title"></h1> 
	  <i class="ic-close icon-size-32" (click)="activeModal.dismiss('Cross click')"></i>
	</div>
	<div class="modal-body">	
    <p class="description-modal" [innerHTML]="data.description"></p>
        <div class="form-group" *ngIf='data?.type !== "workspace"'>
            <app-add-edit-destinations
              [source]='source'
              [didSubmit]='submitted'
              (sendDestinationToParent)='handleDestination($event)'>
            </app-add-edit-destinations>
            <span class="destination-helper" *ngIf='data?.type === "execution"'>An execution must be in workspace › project › folder</span>
            <span class="destination-helper" *ngIf='data?.type === "project"'>A project must be in a specific workspace </span>
            <small class="text-error w-100 d-flex" *ngIf='invalid'>Destination is mandatory. please choose one</small>
          </div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-dark" (click)="onClose()">Cancel</button>
		<button class="btn btn-error" [innerHTML]="data.button" [disabled]='disabledButton' (click)="restoreItem()"></button>
	</div>
</div>
